import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import CompletePaymentDialog from './CompletePaymentDialog';

/**
 * Standalone route for /complete-payment (e.g. bookmarks).
 * Same blocking dialog as the in-app payment gate.
 */
export default function CompletePayment() {
  const navigate = useNavigate();
  const onNoPendingPlan = useCallback(() => {
    navigate('/Dashboard', { replace: true });
  }, [navigate]);

  return <CompletePaymentDialog open onNoPendingPlan={onNoPendingPlan} />;
}
